import { useEffect, useState } from "react";
import { auth } from "../firebase";
import {
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged,
  signOut
} from "firebase/auth";

function Login() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
      setUser(u);
    });
    return () => unsubscribe();
  }, []);

  const login = async () => {
    const provider = new GoogleAuthProvider();
    await signInWithPopup(auth, provider);
  };

  const logout = async () => {
    await signOut(auth);
  };

  return (
    <div className="flex items-center">
      {user ? (
        <div className="flex items-center gap-3 w-full">
          {/* Avatar */}
          <div className="relative flex-shrink-0">
            <img
              src={user.photoURL}
              alt="profile"
              className="w-8 h-8 rounded-full"
              style={{ filter: "grayscale(20%)" }}
            />
            {/* Online dot */}
            <span
              className="absolute bottom-0 right-0 w-2 h-2 rounded-full bg-[#3ec73c]"
              style={{ outline: "2px solid #0e0e0e" }}
            />
          </div>

          {/* Name block */}
          <div className="flex flex-col leading-tight">
            <span className="text-[10px] text-[#666] tracking-[0.15em] uppercase">
              Signed in
            </span>
            <span className="text-sm text-[#e8dcc5] font-medium tracking-tight">
              {user.displayName}
            </span>
          </div>

          {/* Spacer */}
          <div className="flex-1" />

          {/* Logout */}
          <button
            onClick={logout}
            className="text-[11px] tracking-[0.15em] uppercase text-[#f5a623] border border-[#f5a623]/40 px-3 py-1.5 rounded-sm bg-[#f5a623]/10 hover:bg-[#f5a623]/20 transition-all duration-200"
          >
            Sign out
          </button>
        </div>
      ) : (
        <button
          onClick={login}
          className="flex items-center gap-2.5 text-[11px] tracking-[0.15em] uppercase text-[#f5a623] transition-all duration-200 group"
        >
          {/* Google icon */}
          <span
            className="w-6 h-6 rounded-sm flex items-center justify-center border border-[#f5a623]/40 bg-[#f5a623]/10 group-hover:bg-[#f5a623]/20 transition-all duration-200"
          >
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt=""
              className="w-3.5 h-3.5"
              style={{ filter: "grayscale(30%)" }}
            />
          </span>
          Connect with Google
        </button>
      )}
    </div>
  );
}

export default Login;
